export const AlertsService = {

  //error
  errorActionAlert(text,actionType){
    swal.fire({
      title: `${actionType}`,
      icon: `error`,
      text: `${text}`,
      showCancelButton : false,
      allowOutsideClick : false
    })
  },

  errorActionConflictAlert(text,actionType){
    swal.fire({
      title: `${actionType}`,
      icon: `error`,
      html: `${text}`,
      showCancelButton : false,
      allowOutsideClick : false
    })
  },

  //errorWithResponseData
  errorWithResponseData(text,actionType,icon){
    let iconParam  = icon ? icon : `error`;
    swal.fire({
      title: `${actionType.toUpperCase()}`,
      icon: `${iconParam}`,
      html: text,
      showCancelButton : false,
      allowOutsideClick : false
    })
  },


  //info
  async infoActionAlert(text,actionType){
    return  await  swal.fire({
      title : `${actionType}`,
      icon : `info`,
      text: `${text}`,
      customClass:{
        confirmButton: 'btn btn-primary btn-sm font-weight-bolder',
        cancelButton: 'btn btn-secondary btn-sm font-weight-bolder',
      },
      showCancelButton: true,
      allowOutsideClick: false
    }).then((results)=>{
      return results.value;
    });
  },

  //question
  async questionActionAlert(text,actionType,icon){
    return await swal.fire({
      title : `${actionType}`,
      icon : `${icon}`,
      text : `${text}`,
      customClass:{
        confirmButton: 'btn btn-primary btn-sm font-weight-bolder',
        cancelButton: 'btn btn-secondary btn-sm font-weight-bolder',
      },
      showCancelButton: true,
      allowOutsideClick: false
    }).then((result) => {
      return result.value;
    })
  },

  //sucess
  successActionAlert(text,actionType,html){

    let ht = html ? html : '';

    return swal.fire({
      title : `${actionType}`,
      icon : `success`,
      text: `${text}`,
      html : `${ht}`,
      showCancelButton : false,
      allowOutsideClick : false,
    }).then((result)=>{
      return result.value;
    });
  },

  //warning
  warningActionAlert(text,actionType){
    swal.fire({
      title: `${actionType}`,
      icon: `warning`,
      text: `${text}`,
      showCancelButton : false,
      allowOutsideClick : false
    })
  },

  async loading(text){
    return await swal.fire({
      title: 'Auto close alert!',
      text: `${text}`,
      timerProgressBar: true,
      showConfirmButton : false,
      allowOutsideClick : false,
      onOpen: () => {
        swal.showLoading();
      },
    });
  }
};

export default {AlertsService};


